// Import Packages
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

// Import Pages
import FieldLabel from '../../../FlowConfigurationInputs/FieldLabel/FieldLabel';
import VariablePicker from '../../../FlowConfigurationInputs/VariablePicker/VariablePicker';
import { Checkboxes } from '../../../FlowConfigurationInputs';


/**
 * @Description this page Datatable Library's Limit Rows Action configuration form
 * @Param       action - object 
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRenbder - variable render 
 * @Returns     div element
 * @Author      Abdullah Onur Yeşil
 */
export default function MergeTables({ action, variables, setOpenVariable }) {
    const [containsHeader, setContainsHeader] = useState(false);

    const { t } = useTranslation();
    const label = 'CONTENT.CONFIGURATION-FORM.DATA-TABLE.';
    const l = label + 'MERGE-TABLES.';

    useEffect(() => {
        if (!action.fields.containsHeader) {
            action.fields.containsHeader = { value: false }
        }

        setContainsHeader(action.fields.containsHeader.value);
    }, [action.id])

    const changeContainsHeader = (v) => {
        setContainsHeader(v.value);
    }

    return (
        <div>
            <div className="conf-field-container">
                <FieldLabel name={t(l + 'MAIN-TABLE')} is_required />
                <VariablePicker action={action} inputName="mainTable" variables={variables}
                    setOpenVariable={setOpenVariable} filter="data table" isRequired hideRequired />
                <small className="conf-field-desc"><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'data table' })}</em></small>
            </div>
            <div className="conf-field-container">
                <FieldLabel name={t(l + 'TABLES')} is_required />
                <VariablePicker multiSelect={true} action={action} inputName="tables" variables={variables}
                    setOpenVariable={setOpenVariable} filter="data table" isRequired hideRequired />
                <small className="conf-field-desc"><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'data table' })}</em></small>
            </div>
            <div className="conf-field-container">
                <Checkboxes action={action} inputName="containsHeader" options={{ label: label + 'CONTAINS-HEADER' }} onChange={changeContainsHeader} defaultValue={true} />
            </div>
            {containsHeader &&
                <div className="conf-field-container">
                    <Checkboxes action={action} inputName="mergeDataByColumnNames" options={{ label: l + 'MERGE-DATA-BY-COLUMN-NAMES' }} defaultValue={true} />
                </div>
            }

            <div className="conf-field-container">
                <FieldLabel name={t(label + 'ASSIGN-VALUE')} is_required />
                <VariablePicker action={action} inputName="set" variables={variables} setOpenVariable={setOpenVariable}
                    filter={"data table"} isRequired hideRequired />
                <small className='conf-field-desc'><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'data table' })}</em></small>
            </div>
        </div>
    )
}